import React from "react";

import {
    faSquare,
    faSquareCheck,
    faSquareMinus,
    faSquarePlus,
} from "@fortawesome/free-regular-svg-icons";
import {
    faChevronDown,
    faChevronRight,
    faFile,
    faFolder,
    faFolderOpen,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CheckboxTree from "react-checkbox-tree";
import "react-checkbox-tree/lib/react-checkbox-tree.css";

const TREE_ICONS = {
    check: <FontAwesomeIcon icon={faSquareCheck} />,
    uncheck: <FontAwesomeIcon icon={faSquare} />,
    halfCheck: <FontAwesomeIcon icon={faSquareCheck} />,
    expandClose: <FontAwesomeIcon icon={faChevronRight} />,
    expandOpen: <FontAwesomeIcon icon={faChevronDown} />,
    expandAll: <FontAwesomeIcon icon={faSquarePlus} />,
    collapseAll: <FontAwesomeIcon icon={faSquareMinus} />,
    parentClose: <FontAwesomeIcon icon={faFolder} />,
    parentOpen: <FontAwesomeIcon icon={faFolderOpen} />,
    leaf: <FontAwesomeIcon icon={faFile} />,
};

const SftpFileTree = ({ nodes, checked, expanded, onCheck, onExpand }) => (
    <div className="checkbox-tree-area">
        <CheckboxTree
            nodes={nodes}
            checked={checked}
            expanded={expanded}
            onCheck={onCheck}
            onExpand={onExpand}
            icons={TREE_ICONS}
        />
    </div>
);

export default SftpFileTree;
